"use strict";
// @ts-ignore
try {
    self['workbox:streams:7.4.0'] && _();
}
catch (e) { }
